<template>
	<div style="display: flex">
		<div v-for="(day, index) in capacityData" :key="index" class="pa-1">
			<v-card
				width="100"
				height="100%"
				:color="getCardColor(day.isWorkDay)"
				class="text-xs-center"
			>
				<v-flex>
					<strong>{{ formatShortDate(day.date) }}</strong>
				</v-flex>
				<v-layout row>
					<v-flex style="display: flex; justify-content: center; align-items: center">
						<v-btn
							v-if="day.isDeliveryDay"
							flat
							icon
							color="accent"
							class="ma-0 pa-0"
							title="Liefertermin entfernen"
							@click="deleteDeliveryDate(day.date)"
						>
							<v-icon>local_shipping</v-icon>
						</v-btn>
						<v-btn
							v-else
							flat
							icon
							color="grey"
							class="ma-0 pa-0"
							title="Liefertermin hinzufügen"
							@click="addDeliveryDate(day.date)"
						>
							<v-icon>local_shipping</v-icon>
						</v-btn>
						<v-icon v-if="day.isFertigerHoliday" color="#F4511E">beach_access</v-icon>
						<v-icon v-else-if="day.isPublicHoliday" color="accent">beach_access</v-icon>
					</v-flex>
				</v-layout>

				<v-divider style="margin: 0px"></v-divider>
				<div v-if="day.hasCapacities">
					<v-flex> Laser </v-flex>
					<div @click="openEditCapacityDialogue(day.date)" style="cursor: pointer">
						<canvas
							:id="`chart${day.fertigerId}${getUnix(day.date)}Laser`"
							width="100"
							height="60"
						>
						</canvas>
					</div>
					<v-flex> Biegen </v-flex>
					<div @click="openEditCapacityDialogue(day.date)" style="cursor: pointer">
						<canvas
							:id="`chart${fertiger.id}${getUnix(day.date)}Bending`"
							width="100"
							height="60"
						>
						</canvas>
					</div>
					<div v-show="hasWeldingCapacity">
						<v-flex> Schweissen </v-flex>
						<div @click="openEditCapacityDialogue(day.date)" style="cursor: pointer">
							<canvas
								:id="`chart${fertiger.id}${getUnix(day.date)}Welding`"
								width="100"
								height="60"
							>
							</canvas>
						</div>
					</div>
				</div>
				<v-flex v-else>
					<v-btn
						flat
						icon
						color="grey"
						title="Kapazität hinzufügen"
						@click="openEditCapacityDialogue(day.date)"
					>
						<v-icon>add_circle</v-icon>
					</v-btn>
				</v-flex>
			</v-card>
		</div>
		<!-- Kapazität bearbeiten Dialog -->
		<v-dialog v-model="editCapacityDialogue" width="500" persistent>
			<v-form ref="form" v-model="formValid">
				<v-card>
					<v-card-title class="headline grey lighten-2" primary-title>
						<span
							>Kapazitäten vom
							<strong>{{ formatShortDate(editCapacityDate) }}</strong>
							bearbeiten</span
						>
					</v-card-title>
					<v-card-text>
						<v-layout row align-center>
							<v-flex xs4>
								<v-subheader>Fertiger:</v-subheader>
							</v-flex>
							<v-flex xs7>
								<v-text-field
									:disabled="true"
									:value="fertiger.name"
								></v-text-field>
							</v-flex>
							<v-spacer></v-spacer>
						</v-layout>
						<v-divider></v-divider>
						<!-- LASER -->
						<h5>Laser-Kapazität:</h5>
						<v-layout row align-center>
							<v-flex xs4>
								<v-subheader>Aktuell:</v-subheader>
							</v-flex>
							<v-flex>
								<span>{{ displayCurrentLaserCapacity }}</span>
							</v-flex>
						</v-layout>
						<v-layout row align-center>
							<v-flex xs4>
								<v-subheader>Reserviert:</v-subheader>
							</v-flex>
							<v-flex>
								<span>{{ displayUsedLaserCapacity }}</span>
							</v-flex>
						</v-layout>
						<v-layout row align-center>
							<v-flex xs4>
								<v-subheader>Neu:</v-subheader>
							</v-flex>
							<v-flex xs3 mr-2>
								<v-text-field
									v-model="editLaserHours"
									label="Stunden"
									type="number"
									:rules="hoursRules"
									required
								></v-text-field>
							</v-flex>
							<v-flex xs3>
								<v-text-field
									v-model="editLaserMinutes"
									label="Minuten"
									type="number"
									:rules="minutesRules"
									required
								></v-text-field>
							</v-flex>
							<v-spacer></v-spacer>
						</v-layout>
						<!-- BIEGEN -->
						<h5>Biege-Kapazität:</h5>
						<v-layout row align-center>
							<v-flex xs4>
								<v-subheader>Aktuell:</v-subheader>
							</v-flex>
							<v-flex>
								<span>{{ displayCurrentBendingCapacity }}</span>
							</v-flex>
						</v-layout>
						<v-layout row align-center>
							<v-flex xs4>
								<v-subheader>Reserviert:</v-subheader>
							</v-flex>
							<v-flex>
								<span>{{ displayUsedBendingCapacity }}</span>
							</v-flex>
						</v-layout>
						<v-layout row align-center>
							<v-flex xs4>
								<v-subheader>Neu:</v-subheader>
							</v-flex>
							<v-flex xs3 mr-2>
								<v-text-field
									v-model="editBendingHours"
									label="Stunden"
									type="number"
									:rules="hoursRules"
									required
								></v-text-field>
							</v-flex>
							<v-flex xs3>
								<v-text-field
									v-model="editBendingMinutes"
									label="Minuten"
									type="number"
									:rules="minutesRules"
									required
								></v-text-field>
							</v-flex>
							<v-spacer></v-spacer>
						</v-layout>
						<!-- Schweissen -->
						<h5>Schweissen-Kapazität:</h5>
						<v-layout row align-center>
							<v-flex xs4>
								<v-subheader>Aktuell:</v-subheader>
							</v-flex>
							<v-flex>
								<span>{{ displayCurrentWeldingCapacity }}</span>
							</v-flex>
						</v-layout>
						<v-layout row align-center>
							<v-flex xs4>
								<v-subheader>Reserviert:</v-subheader>
							</v-flex>
							<v-flex>
								<span>{{ displayUsedWeldingCapacity }}</span>
							</v-flex>
						</v-layout>
						<v-layout row align-center>
							<v-flex xs4>
								<v-subheader>Neu:</v-subheader>
							</v-flex>
							<v-flex xs3 mr-2>
								<v-text-field
									v-model="editWeldingHours"
									label="Stunden"
									type="number"
									:rules="hoursRules"
									required
								></v-text-field>
							</v-flex>
							<v-flex xs3>
								<v-text-field
									v-model="editWeldingMinutes"
									label="Minuten"
									type="number"
									:rules="minutesRules"
									required
								></v-text-field>
							</v-flex>
							<v-spacer></v-spacer>
						</v-layout>
						<v-divider></v-divider>
						<v-layout row align-center>
							<v-flex xs4 mt-3>
								<v-subheader
									>Für diese Wochentage in Zukunft übernehmen:</v-subheader
								>
							</v-flex>
							<v-flex v-for="weekday in weekdays" :key="weekday.id">
								<v-layout column justify-center>
									<v-flex ml-1>
										{{ weekday.label }}
									</v-flex>
									<v-flex align-top>
										<v-checkbox
											:value="getWeekdayCheckboxValue(weekday.id)"
											@change="toggleWeekday(weekday.id)"
											hide-details
										></v-checkbox>
									</v-flex>
								</v-layout>
							</v-flex>
						</v-layout>
						<div v-if="showEditErrorMessage" mt-3>
							<v-divider></v-divider>
							<span class="error--text"
								>Bei der Verarbeitung ist ein Fehler aufgetreten. Siehe Log.</span
							>
						</div>
					</v-card-text>
					<v-divider></v-divider>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn flat :disabled="isEditing" @click="closeDialogue()">
							Abbrechen
						</v-btn>
						<v-btn
							class="blexon-button"
							flat
							:disabled="isEditing || !formValid"
							@click="editCapacity()"
						>
							<v-progress-circular
								size="16"
								v-if="isEditing"
								indeterminate
							></v-progress-circular>
							Speichern
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-form>
		</v-dialog>
	</div>
</template>

<script>
import httpClient from "../store/httpClient";
import moment from "moment";

export default {
	props: {
		fertiger: Object,
		capacityData: Array,
	},
	data() {
		return {
			editCapacityDialogue: false,
			editCapacityDate: new Date(),
			editLaserCapacityUsed: moment.duration(),
			editLaserCapacityCurrent: moment.duration(),
			editLaserHours: 0,
			editLaserMinutes: 0,
			editBendingCapacityUsed: moment.duration(),
			editBendingCapacityCurrent: moment.duration(),
			editBendingHours: 0,
			editBendingMinutes: 0,
			editWeldingCapacityUsed: moment.duration(),
			editWeldingCapacityCurrent: moment.duration(),
			editWeldingHours: 0,
			editWeldingMinutes: 0,
			showEditErrorMessage: false,
			editApplyForFutureWeekdays: 0,
			editHasUsedCapacity: false,
			isEditing: false,
			formValid: false,
			weekdays: [
				{ id: 1, label: "Mo" },
				{ id: 2, label: "Di" },
				{ id: 3, label: "Mi" },
				{ id: 4, label: "Do" },
				{ id: 5, label: "Fr" },
				{ id: 6, label: "Sa" },
				{ id: 0, label: "So" }, // 0 = Sunday and I want that last
			],

			hoursRules: [
				(v) => v !== "" || "Stunden müssen angegeben werden (0 eingeben).",
				(v) => !isNaN(v) || "Bitte Zahl (ohne Komma) eingeben",
				(v) => v % 1 === 0 || "Bitte nur Ganzzahlen eingeben",
				(v) => (v >= 0 && v < 100) || "Stunden müssen zwischen 0 und 99 liegen",
			],
			minutesRules: [
				(v) => v !== "" || "Minuten müssen angegeben werden (0 eingeben).",
				(v) => !isNaN(v) || "Bitte Zahl (ohne Komma) eingeben",
				(v) => v % 1 === 0 || "Bitte nur Ganzzahlen eingeben",
				(v) => (v >= 0 && v < 60) || "Minuten müssen zwischen 0 und 59 liegen",
			],
		};
	},
	computed: {
		displayCurrentLaserCapacity() {
			return `${this.editLaserCapacityCurrent.get("hours")}h ${this.editLaserCapacityCurrent.get("minutes")}min ${this.editLaserCapacityCurrent.get("seconds")}sec`;
		},
		displayUsedLaserCapacity() {
			return `${this.editLaserCapacityUsed.get("hours")}h ${this.editLaserCapacityUsed.get("minutes")}min ${this.editLaserCapacityUsed.get("seconds")}sec`;
		},
		editNewLaserCapacityMilliseconds() {
			return moment
				.duration(this.editLaserHours, "hours")
				.add(moment.duration(this.editLaserMinutes, "minutes"))
				.asMilliseconds();
		},
		displayCurrentBendingCapacity() {
			return `${this.editBendingCapacityCurrent.get("hours")}h ${this.editBendingCapacityCurrent.get("minutes")}min ${this.editBendingCapacityCurrent.get("seconds")}sec`;
		},
		displayUsedBendingCapacity() {
			return `${this.editBendingCapacityUsed.get("hours")}h ${this.editBendingCapacityUsed.get("minutes")}min ${this.editBendingCapacityUsed.get("seconds")}sec`;
		},
		editNewBendingCapacityMilliseconds() {
			return moment
				.duration(this.editBendingHours, "hours")
				.add(moment.duration(this.editBendingMinutes, "minutes"))
				.asMilliseconds();
		},
		displayCurrentWeldingCapacity() {
			return `${this.editWeldingCapacityCurrent.get("hours")}h ${this.editWeldingCapacityCurrent.get("minutes")}min ${this.editWeldingCapacityCurrent.get("seconds")}sec`;
		},
		displayUsedWeldingCapacity() {
			return `${this.editWeldingCapacityUsed.get("hours")}h ${this.editWeldingCapacityUsed.get("minutes")}min ${this.editWeldingCapacityUsed.get("seconds")}sec`;
		},
		editNewWeldingCapacityMilliseconds() {
			return moment
				.duration(this.editWeldingHours, "hours")
				.add(moment.duration(this.editWeldingMinutes, "minutes"))
				.asMilliseconds();
		},
		hasWeldingCapacity() {
			return this.capacityData.some(
				(c) =>
					c.weldingCapacity > moment.duration(0) ||
					c.weldingUsedCapacity > moment.duration(0)
			);
		},
	},
	methods: {
		openEditCapacityDialogue(date) {
			this.setEditCapacities(date);
			this.editCapacityDate = date;
			this.editLaserHours = this.editLaserCapacityCurrent.get("hours");
			this.editLaserMinutes = this.editLaserCapacityCurrent.get("minutes");
			this.editBendingHours = this.editBendingCapacityCurrent.get("hours");
			this.editBendingMinutes = this.editBendingCapacityCurrent.get("minutes");
			this.editWeldingHours = this.editWeldingCapacityCurrent.get("hours");
			this.editWeldingMinutes = this.editWeldingCapacityCurrent.get("minutes");
			this.editApplyForFutureWeekdays = 0;
			this.editCapacityDialogue = true;
			this.$refs.form.validate();
		},
		closeDialogue() {
			this.editCapacityDialogue = false;
			this.editCapacityDate = new Date();
			this.editLaserCapacityUsed = moment.duration();
			this.editLaserCapacityCurrent = moment.duration();
			this.editLaserHours = 0;
			this.editLaserMinutes = 0;
			this.editBendingCapacityUsed = moment.duration();
			this.editBendingCapacityCurrent = moment.duration();
			this.editBendingHours = 0;
			this.editBendingMinutes = 0;
			this.editWeldingCapacityUsed = moment.duration();
			this.editWeldingCapacityCurrent = moment.duration();
			this.editWeldingHours = 0;
			this.editWeldingMinutes = 0;
			this.showEditErrorMessage = false;
			this.isEditing = false;
		},
		async editCapacity() {
			try {
				this.showEditErrorMessage = false;
				this.isEditing = true;
				await httpClient().post(
					"api/Capacity/AdjustCapacity?" +
						`fertigerId=${this.fertiger.id}` +
						`&capacityDate=${this.editCapacityDate.toJSON()}` +
						`&laserCapacityMilliseconds=${this.editNewLaserCapacityMilliseconds}` +
						`&bendingCapacityMilliseconds=${this.editNewBendingCapacityMilliseconds}` +
						`&weldingCapacityMilliseconds=${this.editNewWeldingCapacityMilliseconds}` +
						`&applyToWeekdaysPattern=${this.editApplyForFutureWeekdays}`
				);

				this.closeDialogue();
				this.$emit("updateCapacity");
			} catch (err) {
				this.showEditErrorMessage = true;
			} finally {
				this.isEditing = false;
			}
		},
		async deleteDeliveryDate(date) {
			try {
				this.isEditing = true;
				await httpClient().post(
					"api/Capacity/DeleteDeliveryDate?" +
						`fertigerId=${this.fertiger.id}` +
						`&deliveryDate=${date.toJSON()}`
				);

				this.closeDialogue();
				this.$emit("updateCapacity");
			} catch (err) {
				this.$emit(
					"showSnackbar",
					"Lieferdatum konnte nicht gelöscht werden. Wahrscheinlich bestehen Reservationen."
				);
			} finally {
				this.isEditing = false;
			}
		},
		async addDeliveryDate(date) {
			try {
				this.isEditing = true;
				await httpClient().post(
					"api/Capacity/AddDeliveryDate?" +
						`fertigerId=${this.fertiger.id}` +
						`&deliveryDate=${date.toJSON()}`
				);

				this.closeDialogue();
				this.$emit("updateCapacity");
				this.$emit("showSnackbar", "Lieferdatum wurde hinzugefügt.");
			} catch (err) {
				this.$emit("showSnackbar", "Lieferdatum konnte nicht hinzugefügt werden");
			} finally {
				this.isEditing = false;
			}
		},
		setEditCapacities(date) {
			var data = this.capacityData.filter((c) => moment(c.date).isSame(date, "day"));
			if (data.length <= 0 || data.length > 1) return 0;
			var dataPoint = data[0];
			this.editHasUsedCapacity =
				dataPoint.laserUsedCapacity.asMilliseconds() > 0 ||
				dataPoint.bendingUsedCapacity.asMilliseconds() > 0 ||
				dataPoint.weldingUsedCapacity.asMilliseconds() > 0;
			this.editLaserCapacityUsed = dataPoint.laserUsedCapacity;
			this.editLaserCapacityCurrent = dataPoint.laserCapacity;
			this.editBendingCapacityUsed = dataPoint.bendingUsedCapacity;
			this.editBendingCapacityCurrent = dataPoint.bendingCapacity;
			this.editWeldingCapacityUsed = dataPoint.weldingUsedCapacity;
			this.editWeldingCapacityCurrent = dataPoint.weldingCapacity;
		},
		formatShortDate(date) {
			return moment(date).format("dd DD.MM");
		},
		getCardColor(isWorkDay) {
			return isWorkDay ? "white" : "rgb(230, 230, 230)";
		},
		getUnix(date) {
			return moment(date).unix();
		},
		getWeekdayCheckboxValue(index) {
			return (this.editApplyForFutureWeekdays & (1 << index)) != 0;
		},
		toggleWeekday(index) {
			this.editApplyForFutureWeekdays = this.editApplyForFutureWeekdays ^ (1 << index);
		},
	},
};
</script>

<style scoped>
.v-input--selection-controls {
	margin: 0px;
	padding: 0px;
}
.v-subheader {
	height: 30px;
}
</style>
